import { getAccessTokenforResource } from 'owa-tokenprovider';
import { trace } from 'owa-trace';

const GRAPH_RESOURCE_URL = 'https://graph.microsoft.com';
let token;

export async function OwaFluidOneDriveService(
    requestUrl: string,
    requestInit: RequestInit,
    requestHeaders?: Record<string, string>
) {
    if (!token) {
        token = await getAccessTokenforResource(GRAPH_RESOURCE_URL);
        if (!token) {
            trace.warn('NO_AUTH_TOKEN');
            return null;
        }
    }

    const headers = new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...requestHeaders,
    });
    requestInit.headers = headers;

    return fetch(requestUrl, requestInit)
        .then(response => response)
        .catch(e => {
            trace.warn('OneDrive service call failed ' + e.message);
            return null;
        });
}

async function hasOperationCompleted(monitorUrl: string) {
    // This URL does not require authentication since this URL is short-lived
    // and unique to the caller.
    return fetch(monitorUrl)
        .then(response => {
            return response.json().then(progressDetails => {
                if (
                    progressDetails.percentageComplete === 100 &&
                    progressDetails.status === 'completed'
                ) {
                    return progressDetails.resourceId;
                }
                return null;
            });
        })
        .catch(e => {
            trace.warn('monitorCopyOperation check failed ' + e.message);
            return null;
        });
}

export async function monitorProgress(monitorUrl: string): Promise<string> {
    const interval = 1000;
    const maxAttempts = 3;
    let attempt: number = 0;
    return new Promise<string>(function (resolve, reject) {
        (async function waitForCopyOperationToComplete() {
            attempt++;
            const newResourceId = await hasOperationCompleted(monitorUrl);
            if (newResourceId) {
                return resolve(newResourceId);
            } else if (attempt == maxAttempts) {
                return reject(new Error('waitForCopyOperationToComplete max attempts exhausted'));
            }
            setTimeout(waitForCopyOperationToComplete, interval);
        })();
    }).catch(e => {
        trace.warn(e.message);
        return null;
    });
}
